import views from '../views'

export default [
    {
        name: 'waiterQRcode',
        path: '/storeModule/waiterQRcode',
        component: views.storeModule.waiterQRcode,
        meta: {
            title:"门店服务员登记二维码"
        }
    },
    {
        name: 'serverMsg',
        path: '/storeModule/serverMsg',
        component: views.storeModule.serverMsg,
        meta: {
            title:"门店服务员信息登记"
        }
    },
    {
        name: 'success',
        path: '/storeModule/success',
        component: views.storeModule.success,
        meta: {
            title:"验证结果"
        }
    },
    {
        name: 'error',
        path: '/storeModule/error',
        component: views.storeModule.error,
        meta: {
            title:"验证结果"
        }
    },
    {
        name: 'waitersList',
        path: '/storeModule/waitersList',
        component: views.storeModule.waitersList,
        meta: {
            title:"服务员列表"
        }
    },
    {
        name: 'waitersDetail',
        path: '/storeModule/waitersDetail',
        component: views.storeModule.waitersDetail,
        meta: {
            title:"扫码记录及中奖情况"
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/storeModule.js